import type { LayoutAnimationTarget } from './types';
import type { AllProps } from '../../propsMixin/props';

export function adaptTarget(target: LayoutAnimationTarget): AllProps {
  const result: AllProps = {};

  if (isDefined(target?.x)) result.x = target.x;
  if (isDefined(target?.y)) result.y = target.y;
  if (isDefined(target?.width)) result.width = target.width;
  if (isDefined(target?.height)) result.height = target.height;
  if (isDefined(target?.angle)) result.angle = target.angle;
  if (isDefined(target?.alpha)) result.alpha = target.alpha;
  if (isDefined(target?.scale?.x)) result.scaleX = target.scale.x;
  if (isDefined(target?.scale?.y)) result.scaleY = target.scale.y;
  if (isDefined(target?.pivot?.x)) result.pivotX = target.pivot.x;
  if (isDefined(target?.pivot?.y)) result.pivotY = target.pivot.y;
  if (isDefined(target?.anchor?.x)) result.anchorX = target.anchor.x;
  if (isDefined(target?.anchor?.y)) result.anchorY = target.anchor.y;
  if (isDefined(target?.textureName)) result.texture = target.textureName;

  return result;
}

function isDefined(value: unknown): value is number {
  return value !== undefined;
}
